import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { ControlModeTemplate } from '@src/types/ControlModes';

interface UseGetControlModeTemplateByIdProps {
  id: string;
  enabled?: boolean;
}

export default ({ id, enabled = true }: UseGetControlModeTemplateByIdProps) =>
  useApiQuery<ControlModeTemplate>({
    queryKey: [QueryKeys.controlModeTemplates, id],
    apiPath: `/control-mode-templates/${id}`,
    method: 'GET',
    useV2API: true,
    enabled,
  });
